/* eslint-disable class-methods-use-this */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import BUILD_COMMIT_HASH from '../../build_info';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showBuildHash: false,
    };
  }

  render() {
    const footerText = this.state.showBuildHash
      ? (BUILD_COMMIT_HASH || 'unknown')
      : 'Raar.';

    return (
      <footer className="footer">
        <div className="container-fluid">
          <Row>
            <Col sm={6}>
              {new Date().getFullYear()}
              {' '}
              © ShopJimmy.com.
            </Col>
            <Col sm={6}>
              <div
                className="text-sm-end d-none d-sm-block"
                onMouseEnter={() => this.setState({ showBuildHash: true })}
                onMouseLeave={() => this.setState({ showBuildHash: false })}
              >
                {footerText}
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    );
  }
}

export default Footer;
